import { useId } from "react";
import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

import { ChartCard } from "./ChartCard";
import { AXIS_TEXT_COLOR, formatCount, GRID_COLOR, PRIMARY_COLOR } from "./chartPalette";

const formatDateTick = (isoDate) => {
  if (!isoDate) return "";
  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) return isoDate;
  return date.toLocaleDateString("en-IE", { day: "2-digit", month: "short" });
};

export const TrendChartCard = ({
  title,
  data = [],
  isLoading,
  dataKey = "count",
  valueFormatter = formatCount,
  color = PRIMARY_COLOR,
}) => {
  const gradientId = `trendFill-${useId()}`;

  return (
    <ChartCard title={title} isLoading={isLoading} isEmpty={!isLoading && data.length === 0}>
      <ResponsiveContainer width="100%" height={220}>
        <AreaChart data={data} margin={{ top: 8, right: 16, bottom: 0, left: 0 }}>
          <defs>
            <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor={color} stopOpacity={0.35} />
              <stop offset="95%" stopColor={color} stopOpacity={0.02} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke={GRID_COLOR} vertical={false} />
          <XAxis
            dataKey="label"
            tickFormatter={formatDateTick}
            tick={{ fontSize: 12, fill: AXIS_TEXT_COLOR }}
            minTickGap={24}
          />
          <YAxis tick={{ fontSize: 12, fill: AXIS_TEXT_COLOR }} tickFormatter={valueFormatter} width={56} allowDecimals={false} />
          <Tooltip labelFormatter={formatDateTick} formatter={(value) => valueFormatter(value)} />
          <Area type="monotone" dataKey={dataKey} stroke={color} strokeWidth={2} fill={`url(#${gradientId})`} />
        </AreaChart>
      </ResponsiveContainer>
    </ChartCard>
  );
};
